import { Component, OnInit, OnChanges, Input, Output, EventEmitter,HostBinding  } from '@angular/core';
import { trigger, style, animate, transition, keyframes, query } from '@angular/animations';
import { ApiService } from "../api.service";
import {CommonService} from '../common.service';

declare var $ :any;
declare var polyvPlayer :any;

@Component({
  selector: 'app-case-practice-team-video',
  animations: [
   trigger(
     'videoAnimation', [
       transition(':enter', [
         style({opacity: 0}),
         animate('1s ease-out', style({opacity: 1}))
       ]),
       transition(':leave', animate('500ms', keyframes([
          style({opacity: 1, transform: 'scale(1, 1)'}),
          style({opacity: 0, transform: 'scale(0, 0)'})
        ]))),
   ])
  ],
  templateUrl: './case-practice-team-video.component.html',
  styleUrls: ['./case-practice-team-video.component.css']
})
export class CasePracticeTeamVideoComponent implements OnInit, OnChanges {

    @Input() pageToVideo: string;
    @Input() showCloseBtn: Boolean;
    @Input() isPC: boolean;
    @Output() onGoToQuestion = new EventEmitter<any>();
    @Output() onGoToBegin = new EventEmitter<any>();

  showVideo:Boolean = true;
  assetsRoute: string = "../../assets";
  constructor(private apiService: ApiService,private commonService:CommonService) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    let _this = this;
    _this.showVideo = true;
    window['s2j_onPlayOver'] = function () {
    	_this.closeVideo();
      _this.apiService.ajax({
          'type': 'post',
          'url': '/sr/onceino/401',
          'data': {}
      }).subscribe(result => {
        // _this.onGoToBegin.emit(true);
      });
    };

  }

  ngAfterViewInit(){
    var player = polyvPlayer({
      wrap: '#video',
      // width: '100vw',
      // height: '100vh',
      width: '100%',
      height: this.isPC ? '100vh' : window.screen.width/9*16,
      vid: '352e2664d84ea777898bd0e732868466_3',
      // autoplay: true,
      // skinLocation: 0,
      ban_history_time: 'on',
      // hideSwitchPlayer: true,
      hideRepeat: true,
      // forceH5: true,
      flashvars: {'autoplay': true}
      // audioMode: false

    });

    if(!this.isPC){
      player.toggleFullscreen();
    }
  }

  ngOnChanges(){

  }

  closeVideo(){
  	let _this = this;
  	$("#videoShortCut").show();
    	_this.showVideo = false;
    	setTimeout(function(){
    		if(_this.pageToVideo=='begin'){
	        _this.onGoToBegin.emit(true);
	      }else{
	        _this.onGoToQuestion.emit(true);
	      }
		},300)
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-team-video/case-practice-team-video.component.ts